import { confirmable } from 'react-confirm';
import StackedModal from './stacked_modal';
import { useTranslation } from 'react-i18next';

function DeactivateDialog({ show, proceed, title, content, confirmText }) {
  const { t } = useTranslation('common');
  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:status.inactive')}
      content={content || t('common:confirmation.deactivate')}
      primaryAction={{
        content: confirmText || t('common:button.confirm'),
        onAction: () => {
          proceed(true);
        },
      }}
      onClose={() => {
        proceed(false);
      }}
    />
  );
}

export default confirmable(DeactivateDialog);
